// extracted by mini-css-extract-plugin
export default {"cells":"TotalHours_cells__ZPJ4r","hourstotal":"TotalHours_hourstotal__oIbNI"};